<div class="animated fadeIn container-fluid" [formGroup]="form">
    <h4>{{ title }} Registro Sanitario</h4>

    <div class="row">
        <div class="col-md-12">

            <div class="row">

                <div class="col-md-12">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> Datos del Registro Sanitario
                                <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="intRegistroSanitario">Registro Sanitario</label>
                                        <input formControlName="RegistroSanitario" name="RegistroSanitario" class="form-control" maxlength="16" inputStyleClass="form-control" [ngClass]="displayFieldCss('RegistroSanitario')" type="text" value="">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RegistroSanitario','required')">
                                            El Registro Sanitario es obligatorio
                                        </div>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RegistroSanitario','registry_duplicated', true)">
                                            El Registro Sanitario ya existe
                                        </div>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="col-form-label required-field" for="intRazonSocial">Razón Social</label>
                                        <input formControlName="RazonSocial" name="RazonSocial" class="form-control" maxlength="60" inputStyleClass="form-control" [ngClass]="displayFieldCss('RazonSocial')" type="text" value="">

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('RazonSocial','required')">
                                            La Razón Social es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intDireccion">Dirección</label>
                                        <input formControlName="Direccion" name="Direccion" class="form-control" maxlength="60" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                </div>

                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intMunicipio">Municipio</label>
                                        <input formControlName="Municipio" name="Municipio" class="form-control" maxlength="60" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intProvincia">Provincia</label>
                                        <input formControlName="Provincia" name="Provincia" class="form-control" maxlength="60" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="intCa">Comunidad Autónoma</label>
                                        <input formControlName="Ca" name="Ca" class="form-control" maxlength="60" inputStyleClass="form-control" type="text" value="">
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label required-field" for="inpActivo">Activo</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="Activo" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
